import {
  resendOtp,
  sendOtp,
  verifyOtp
} from "./chunk-KXEKEMBD.mjs";
import {
  __spreadProps,
  __spreadValues
} from "./chunk-RGHW4PYM.mjs";

// src/hooks/wbk/auth/otp.ts
import { useMutation, useQueryClient } from "@tanstack/react-query";
var useVerifyOtp = ({ lang }) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: verifyOtp,
    onSuccess: () => {
      queryClient.setQueryData(["user", { lang }], (oldUser) => {
        if (oldUser) {
          return __spreadProps(__spreadValues({}, oldUser), {
            email_verified: true,
            force_verify_email: false
          });
        }
        return oldUser;
      });
    }
  });
};
var useSendOtp = () => {
  return useMutation({
    mutationFn: sendOtp
  });
};
var useResendOtp = () => {
  return useMutation({
    mutationFn: resendOtp
  });
};

export {
  useVerifyOtp,
  useSendOtp,
  useResendOtp
};
//# sourceMappingURL=chunk-7KC7R4NL.mjs.map